import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { EstudioForm } from './components/Estudio';

export const MultiFormEstudios = ({ formsStatus='checked', laboratorio, name, onFormsChange, reset, setFormValidation, value }) => {

    const [elements, setElements] = useState((typeof value !== 'undefined') ? value.map(val => ({ id: val.id, estudio: val.estudio, validation: true })) : [])

    const handleAddElement = () => {
        setElements([...elements, { id: moment().unix(), estudio: '', validation: false }]);
    }

    const handleRemoveElement = (id) => {
        setElements(elements.filter(element => element.id !== id));
    }

    const handleSetElementData = (data) => {
        setElements(elements.map(element => {
            if(element.id === data.id){
                return data;
            }else{
                return element;
            }
        }));
    }

    useEffect(() => {
        onFormsChange({ target: { name: name, value: elements.map(element => ({
            id: element.id,
            estudio: element.estudio,
        })) } });
        let errorElements = elements.filter(element => (!element.validation));
        setFormValidation(name, (errorElements.length === 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements])

    useEffect(() => {
        setElements((typeof value !== 'undefined') ? value.map(val => ({ id: val.id, estudio: val.estudio, validation: true })) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reset])

    return (
        <>
            {elements.map((element, index) => <EstudioForm
                key={element.id}
                addElement={handleAddElement}
                element={element}
                last={(index === elements.length - 1)}
                laboratorio={laboratorio}
                removeElement={handleRemoveElement}
                onFormChange={handleSetElementData}
                formStatus={formsStatus}
            />)}
        </>
    )
}

MultiFormEstudios.propTypes = {
    formsStatus: PropTypes.oneOf(['checked', 'checking']),
    laboratorio: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    onFormsChange: PropTypes.func.isRequired,
    reset: PropTypes.number,
    setFormValidation: PropTypes.func,
    value: PropTypes.array
}